import { useEffect } from 'react';

export const useResetRankSettings = (rankSettings: any, reset: Function) => {
  useEffect(() => {
    if (rankSettings) {
      reset({ rankSettings });
    }
  }, [rankSettings, reset]);
};